// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"168":"9c0f3978","827":"ac0138c1","904":"82e81462"}[chunkId] + ".css";
};